import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/authTenantSlice";

import authTenantApis from "src/api/authTenant";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// login request saga
const LoginRequestSaga = function* LoginRequestSaga({
  payload,
}: ReturnType<typeof actions.loginRequest> & {
  payload: { email: string; password: string };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.login,
      payload
    );

    yield put(actions.loginRequestSuccess(response as any));
  } catch (error) {
    yield put(
      actions.loginRequestError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get user details saga
const GetUserDetailsRequestSaga =
  function* GetUserDetailsRequestSaga({}: ReturnType<
    typeof actions.getUserDetailsRequest
  >) {
    try {
      const response: common.ResponseGenerator = yield call(
        authTenantApis.getUserDetails
      );

      console.log("response", response);

      yield put(
        actions.getUserDetailsSuccess({ data: (response as any)?.user } as any)
      );
    } catch (error) {
      yield put(
        actions.getUserDetailsError(
          error instanceof Error
            ? error?.message
            : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
        )
      );
    }
  };

// edit user request saga
const EditUserRequestSaga = function* EditUserRequestSaga({
  payload,
}: ReturnType<typeof actions.editUserRequest> & {
  payload: {
    firstName: string;
    lastName?: string;
    email: string;
    password?: string;
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.updateProfile,
      payload
    );

    yield put(actions.editUserSuccess(response as any));
  } catch (error) {
    yield put(
      actions.editUserError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

export default function* authTenantSaga() {
  yield all([takeEvery(actions.loginRequest, LoginRequestSaga)]);
  yield all([
    takeEvery(actions.getUserDetailsRequest, GetUserDetailsRequestSaga),
  ]);
  yield all([takeEvery(actions.editUserRequest, EditUserRequestSaga)]);
}
